import { Spinner } from "@metsooutotec/modes-react-components"
import { ProvisionEventEquipment, ProvisionEquipmentSensorListItem } from "features/provisioning/provisions/models/provision-models"
import React, { Suspense } from "react"
import { Await, Outlet, Params, useLoaderData } from "react-router-dom"
import provisionEventStore from "features/provisioning/provisions/stores/provision-event-store"
import linerMaterialStore from "features/provisioning/liner-material-library/stores/liner-material-store"
import sensorStockStore from "features/provisioning/provisions/stores/sensor-stock-store"

export async function provisionEventEquipmentDataLoader({
    params,
}: {
    params: Params<string>
}): Promise<{
    provisionEvents: Promise<ProvisionEventEquipment[]>
    linerMaterials: Promise<void>
    availableSensors: Promise<ProvisionEquipmentSensorListItem[]>
}> {
    const { loadProvisionEventsForAsset } = provisionEventStore
    const { loadAllLinerMaterials } = linerMaterialStore
    const { loadAvailableSensors } = sensorStockStore

    const { assetId } = params as { assetId: string }

    return {
        provisionEvents: loadProvisionEventsForAsset(assetId),
        linerMaterials: loadAllLinerMaterials(),
        availableSensors: loadAvailableSensors(assetId),
    }
}

const ProvisionEventsEquipmentLoader: React.FC = () => {
    const data = useLoaderData() as { provisionEvents: Promise<ProvisionEventEquipment[]> }

    return (
        <Suspense fallback={<Spinner text={"Loading equipment"} />}>
            <Await
                resolve={data.provisionEvents}
                children={(provisionEventEqupment: ProvisionEventEquipment[]) => <Outlet context={{ provisionEventEqupment }} />}
            />
        </Suspense>
    )
}

export default ProvisionEventsEquipmentLoader
